export default "__VITE_ASSET__C3HC9P5e__"